import type { BillingProduct } from '@/api/admin-billing';

/**
 * Shared plan-facet primitives for the admin roster plan filters.
 *
 * The /admin/subscriptions client-side filter model retired when that page
 * merged into /admin/users (the roster is now fully server-driven - search,
 * filters, sort and paging run in the `admin_list_users` RPC). What remains here
 * is the plan-facet vocabulary both pages share: the display ladder and the
 * code -> title helper.
 * /admin/users builds its Alfie-plan options from the RPC's `plan_catalog` in
 * lib/admin/user-filters.ts and reuses these. The grouped option/label helpers
 * retired with the roster redesign: K&C tiers filter through the Tier control
 * now, so there is no product-grouped plan dropdown left to label.
 */

/** "FOUNDERS_TABLE" → "Founders Table". */
export function planTitle(code: string): string {
  return code
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

// Display ladders; codes not listed here sort after, alphabetically. Shared
// with /admin/users (lib/admin/user-filters.ts) so both roster and subscription
// plan facets order identically.
export const PLAN_ORDER: Record<BillingProduct, string[]> = {
  alfie: ['PRO', 'BUSINESS', 'ENTERPRISE', 'FREE'],
  kc: ['BASECAMP', 'WUNDERPACK', 'VAULT', 'K2K', 'INNER_CIRCLE', 'FOUNDERS_TABLE'],
};
